import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import vuetify from './plugins/vuetify';
import moment from 'moment';
import {incompleteQuery} from '@/utils/checkQuery.js';

moment.locale(navigator.language || navigator.userLanguage); // TODO revisar si funciona
Vue.prototype.$moment = moment;
Vue.use(Vuetify)
Vue.config.productionTip = false
const opts = {}

new Vue({
  data() {
    return {
      outsideNames: [
        'Login',
        'Registro',
        'Confirmar',
        'CambiarPassword',
      ],
    }
  },
  watch: {
    '$route' (to, from) {
      this.checkLoginStatus();
    }
  },
  mounted() {
    this.checkLoginStatus();
  },
  methods: {
    checkLoginStatus() {
      const name = this.$route.name;
      // Caso para /firmar con query string
      if (name === 'Firmar') {
        const query = this.$route.query;
        const requiredParams = ['c', 'd'];
        if (!incompleteQuery(query, requiredParams)) return;
      }
      // Caso para /confirmar con query string
      if (name === 'Confirmar') {
        const query = this.$route.query;
        const requiredParams = ['u'];
        if (!incompleteQuery(query, requiredParams)) return;
      }
      // Caso para /test (página de pruebas)
      if (name === 'Test') return;
      // Caso general (hacer logout si faltan datos de login)
      const token = this.$store.getters.getToken;
      const user = this.$store.getters.getUser;
      const cliente = this.$store.getters.getClient;
      this.$store.dispatch('setToken', token);
      this.$store.dispatch('setUser', user);
      this.$store.dispatch('setClient', cliente);
      if (!this.validClienteId(cliente) || !this.validToken(token) || !this.validUser(user)) {
        if (this.outsideNames.indexOf(name) === -1) this.$store.dispatch('logout');
        return;
      }
      // Si tiene datos de login completos, no debe estar "fuera" (en alguno de outsideNames)
      // redirige a /menu
      if (this.outsideNames.indexOf(name) > -1) this.$router.push({name: 'Menu'});
    },
    validClienteId(clienteId) {
      if (typeof clienteId === 'number' && clienteId > 0) return true;
      return false;
    },
    validToken(token) {
      if (typeof token === 'string' && token.length > 0) return true;
      return false;
    },
    validUser(user) {
      if (typeof user === 'object' && Object.keys(user).length > 0) return true;
      return false;
    },
  },
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

export default new Vuetify(opts)